import http from "./http.js"
/**
 * post、get、put
 * http.post('url', params);
 * url:接口
 * params:参数
    {
      header:{
        type:'',
        role:''
      },
      body:{

      },
      query:{

      }
    }
 */

//系统用户登录 (获取 Jwt 授权数据) 钉钉扫码登录
export const userDDLogin = params => {
  return http.post("/token", params)
}
//系统用户登录 (获取 Jwt 授权数据)
export const userLogin = params => {
  return http.post("/token", params)
}
export const refreshToken = params => {
  return http.post("/token", params)
}
export const verifyToken = params => {
  return http.post("/token", params)
}
// 用户信息 (列表、增、删、改、查) action='***'
export const getUserManage = params => {
  return http.post("/user_manage", params)
}
// 医院信息 (列表、增、删、改、查) action='***'  医院负责人修改
export const getHospitalManage = params => {
  return http.post("/hospital_manage", params)
}
export const getHospitalAll = params => {
  return http.postres("/hospital_manage", params)
}
// 服务器信息 (列表、增、删、改、查) action='***'
export const getServerManage = params => {
  return http.post("/server_manage", params)
}
// 获取标签
export const getServerManageLabel = params => {
  return http.postres("/server_manage", params)
}
// 数据库信息 (列表、增、删、改、查) action='***'
export const getInstanceManage = params => {
  return http.post("/instance_manage", params)
}
// 应用信息 (列表、增、删、改、查) action='***'
export const getAppManage = params => {
  return http.post("/app_manage", params)
}
// 项目信息 (列表、增、删、改、查) action='***'
export const getProjectManage = params => {
  return http.post("/project_manage", params)
}
// 工单信息 (列表、增、删、改、查) action='***'
export const getWorkOrder = params => {
  return http.post("/work_order", params)
}
// 第三方服务器信息 (列表、增、删、改、查) action='***'
export const getThirdpartyManage = params => {
  return http.post("/thirdparty_manage", params)
}
// 投诉 (列表、增、删) action='***'
export const getComplaintManage = params => {
  return http.post("/complaint_manage", params)
}
// 排班  month: cur:当月；pre:上个月；next:下个月
export const getDuty = params => {
  return http.post("/duty", params)
}

// 项目统计
export const getStatistics = params => {
  return http.post("/statistics", params)
}

export const getWorkOrderAdd = params => {
  return http.postres("/work_order", params)
}
export const getHospSearch = params => {
  return http.getres("/search", params)
}
// 文档跳转接口
export const postWinOpenUrl = params => {
  return http.post("/document", params)
}



// WEBPACK FOOTER //
// ./src/modules/web/api/api.js